.app-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 44px;
    padding: 0 16px;
    /* background-color: var(--bg-primary); Removed for gradient */
    background: linear-gradient(to bottom, var(--header-bg-start), transparent);
    border-bottom: none;
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
    color: var(--text-primary);
    flex-shrink: 0; /* Prevent header from shrinking */
    width: 100%;
    box-sizing: border-box;
    position: sticky;
    top: 0;
    z-index: 1100; /* Above overlays like Pause and Streaks */
}

.header-left, .header-right {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
}

.header-right {
    justify-content: flex-end;
}

/* Leading-aligned, the way the native screens title their nav bars, rather than
   centred. Takes the free space so right-hand actions stay pinned to the edge. */
.header-center {
    flex: 1;
    min-width: 0;
    display: flex;
    justify-content: flex-start;
}

.app-title {
    /* Sized and weighted to the compact title beside the hamburger in the main
       feed — not a UIKit large title, which that screen does not use. */
    font-size: 1.4rem;
    font-weight: 700;
    margin: 0;
    color: var(--text-primary);
    letter-spacing: -0.02em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.header-back-button {
    background: transparent;
    border: none;
    cursor: pointer;
    color: var(--text-primary);
    padding: 8px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s;
    /* Negative left keeps the glyph optically on the 16px gutter; the right
       margin is the only spacing between it and the title, so an empty
       `.header-left` cannot push the title off that same gutter. */
    margin-left: -8px;
    margin-right: 4px;
}

.header-back-button:hover {
    background-color: var(--bg-hover);
}

.header-back-button svg {
    width: 24px;
    height: 24px;
    fill: currentColor;
}

@media (prefers-color-scheme: light) {
    body.home-view .app-header {
        background: var(--header-background, rgba(255, 255, 255, 0.75));
        border-bottom: var(--header-border, 1px solid rgba(255, 255, 255, 0.2));
        backdrop-filter: blur(12px);
        -webkit-backdrop-filter: blur(12px);
    }
}

@media (max-height: 600px) {
    .app-header {
        height: 36px; /* Shrink header */
        /* Horizontal padding stays at 16px even here: narrowing it saves no
           vertical space and pulls the title off the content gutter. */
        padding: 0 16px;
    }
    .app-title {
        font-size: 1.25rem;
    }
}
